import React, { LegacyRef } from "react";
import "./Banner.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    component: React.ReactNode;
    descriptions: React.ReactNode[];
}

const InfoBanner = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <div className="userful-warning-banner-wrapper">
            <div className="userful-warning-banner-icon-wrapper">{props.component}</div>
            <div className="userful-warning-banner-text-wrapper">
                {props.descriptions.map((description) => {
                    return description;
                })}
            </div>
        </div>
    );
};
export default InfoBanner;
